import { render, staticRenderFns } from "./PicFolderTree.vue?vue&type=template&id=6091f728&scoped=true"
import script from "./PicFolderTree.vue?vue&type=script&lang=js"
export * from "./PicFolderTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6091f728",
  null
  
)

export default component.exports